import Login from './SCBZ/Login';
import Logout from './SCBZ/Logout';
import EnterDrawTicket from './SCBZ/EnterDrawTicket';
import GetEntries from './SCBZ/GetEntries';
import GetPlayerData from './SCBZ/GetPlayerData';
import SetEntryFlashGameFlag from './SCBZ/SetEntryFlashGameFlag';
import GetWinners from './SCBZ/GetWinners';

import Update from './FauxAPI/Update';
import Register from './FauxAPI/Register';
import Winners from './FauxAPI/Winners';
import GetCsrfToken from './FauxAPI/GetCsrfToken';
import PostFeedback from './FauxAPI/PostFeedback';
import ForgotPassword from './FauxAPI/ForgotPassword';
import GetGame from './FauxAPI/GetGame';
import GetGameOver from './FauxAPI/GetGameOver';

import LoginL2 from './Loyalty2/Login';
import PTALoginL2 from './Loyalty2/PTALogin';
import LogoutL2 from './Loyalty2/Logout';
import GetPlayerDataL2 from './Loyalty2/GetPlayerData';
import EnterTicketL2 from './Loyalty2/EnterTicket';
import GetAchievements from './Loyalty2/GetAchievements';
import GetPoints from './Loyalty2/GetPoints';
import GetActivity from './Loyalty2/GetActivity';
import GetReward from './Loyalty2/GetReward';
import GetPromotions from './Loyalty2/GetPromotions';
import GetPlayerPromotions from './Loyalty2/GetPlayerPromotions';
import PostFeedbackL2 from './Loyalty2/PostFeedback';
import GetSweeps from './Loyalty2/GetSweeps';
import WinnersL2 from './Loyalty2/Winners';
import GetConfig from './Loyalty2/GetConfig';
import GetRevealToken from './Loyalty2/GetRevealToken';

/*
    In order to return a route here, include in the config object a callout for
    each route you intend to use, and the name of the available api call below.
    example config:
    {
        appUrl: "/jamesbondlotterychallenge",
        routes: {
            login: "scbzApi.login",
            logout: "scbzApi.logout",
            enterDrawTicket: "scbzApi.enterDrawTicket",
            getEntries: "scbzApi.getEntries",
            getPlayerData: "scbzApi.getPlayerData",
            setEntryFlashGameFlag: "scbzApi.setEntryFlashGameFlag",
            update: "fauxScbzApi.update",
            register: "fauxScbzApi.register",
            winners: "fauxScbzApi.winners",
            postFeedback: "fauxScbzApi.postFeedback",
            forgotPassword: "fauxScbzApi.forgotPassword",
            getGame: "fauxScbzApi.getGame",
            getGameOver: "fauxScbzApi.getGameOver",
        }
    }
*/

export default config => {
    const availableApis = {
        scbzApi: {
            login: Login(config),
            logout: Logout(config),
            enterDrawTicket: EnterDrawTicket(config),
            getEntries: GetEntries(config),
            getPlayerData: GetPlayerData(config),
            setEntryFlashGameFlag: SetEntryFlashGameFlag(config),
            getWinners: GetWinners(config),
        },
        fauxScbzApi: {
            update: Update(config),
            register: Register(config),
            winners: Winners(config),
            getCsrfToken: GetCsrfToken(config),
            postFeedback: PostFeedback(config),
            forgotPassword: ForgotPassword(config),
            getGame: GetGame(config),
            getGameOver: GetGameOver(config),
        },
        loyalty2: {
            login: LoginL2(config),
            ptaLogin: PTALoginL2(config),
            getPlayerData: GetPlayerDataL2(config),
            logout: LogoutL2(config),
            enterTicket: EnterTicketL2(config),
            getAchievements: GetAchievements(config),
            getPoints: GetPoints(config),
            getActivity: GetActivity(config),
            getReward: GetReward(config),
            getPromotions: GetPromotions(config),
            getPlayerPromotions: GetPlayerPromotions(config),
            postFeedback: PostFeedbackL2(config),
            getSweeps: GetSweeps(config),
            winners: WinnersL2(config),
            getConfig: GetConfig(config),
            getRevealToken: GetRevealToken(config),
        },
        resolve: (list, desc) => {
            if (desc) {
                var obj = { ...list };
                var arr = desc.split('.');
                while (arr.length && (obj = obj[arr.shift()]));
                return obj;
            } else {
                return undefined;
            }
        },
    };

    return {
        login: availableApis.resolve(availableApis, config.routes.login),
        logout: availableApis.resolve(availableApis, config.routes.logout),
        enterDrawTicket: availableApis.resolve(
            availableApis,
            config.routes.enterDrawTicket
        ),
        enterScratchTicket: availableApis.resolve(
            availableApis,
            config.routes.enterScratchTicket
        ),
        enterFastPlayTicket: availableApis.resolve(
            availableApis,
            config.routes.enterFastPlayTicket
        ),
        getEntries: availableApis.resolve(
            availableApis,
            config.routes.getEntries
        ),
        getPlayerData: availableApis.resolve(
            availableApis,
            config.routes.getPlayerData
        ),
        setEntryFlashGameFlag: availableApis.resolve(
            availableApis,
            config.routes.setEntryFlashGameFlag
        ),
        update: availableApis.resolve(availableApis, config.routes.update),
        register: availableApis.resolve(availableApis, config.routes.register),
        winners: availableApis.resolve(availableApis, config.routes.winners),
        getWinners: availableApis.resolve(
            availableApis,
            config.routes.getWinners
        ),
        getCsrfToken: availableApis.resolve(
            availableApis,
            config.routes.getCsrfToken
        ),
        postFeedback: availableApis.resolve(
            availableApis,
            config.routes.postFeedback
        ),
        forgotPassword: availableApis.resolve(
            availableApis,
            config.routes.forgotPassword
        ),
        getGame: availableApis.resolve(availableApis, config.routes.getGame),
        getGameOver: availableApis.resolve(
            availableApis,
            config.routes.getGameOver
        ),
        getAchievements: availableApis.resolve(
            availableApis,
            config.routes.getAchievements
        ),
        getPoints: availableApis.resolve(
            availableApis,
            config.routes.getPoints
        ),
        getActivity: availableApis.resolve(
            availableApis,
            config.routes.getActivity
        ),
        getReward: availableApis.resolve(
            availableApis,
            config.routes.getReward
        ),
        getPromotions: availableApis.resolve(
            availableApis,
            config.routes.getPromotions
        ),
        getPlayerPromotions: availableApis.resolve(
            availableApis,
            config.routes.getPlayerPromotions
        ),
        getSweeps: availableApis.resolve(
            availableApis,
            config.routes.getSweeps
        ),
        getConfig: availableApis.resolve(
            availableApis,
            config.routes.getConfig
        ),
        getRevealToken: availableApis.resolve(
            availableApis,
            config.routes.getRevealToken
        ),
    };
};
